import * as React from "react";

const StripPriceLoader = () => {
    return (
        <div id="dummyPriceInvPlaceHolder" className="content-loader at-element-marker">
            <div className="content-sm space-top content-placeholder"></div>
            <div className="content-xs space-top content-placeholder"></div>
            <div className="horizontal-rule space-top space-bottom"></div>
            <div className="content-md space-top content-placeholder"></div>
            <div className="row">
                <div className="col-md-6 content-lg content-placeright space-top content-placeholder"></div>
            </div>
            <div className="horizontal-rule space-top space-bottom"></div>
            <div className="content-xs space-top content-placeholder"></div>
            <div className="content-sm space-top space-bottom content-placeholder"></div>
        </div>
    );
};

export default StripPriceLoader;
